import { render, staticRenderFns } from "./ApplicantIcon.vue?vue&type=template&id=33cc7b66"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33cc7b66')) {
      api.createRecord('33cc7b66', component.options)
    } else {
      api.reload('33cc7b66', component.options)
    }
    module.hot.accept("./ApplicantIcon.vue?vue&type=template&id=33cc7b66", function () {
      api.rerender('33cc7b66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/ApplicantIcon.vue"
export default component.exports